import { gql } from '@apollo/client';

export const getPriceLadder = gql`
    query getPriceLadderAttributeLevelData(
        $filters: JSONString
        $timePeriod: JSONString!
        $attributeType: SamyaString
        $dimension: SamyaString
        $version: SamyaString!
        $frequency: String!
        $salesFilter: Float
        $limit: Int!
        $offset: Int!
    ) {
        getPriceLadderAttributeLevelData(
            filters: $filters
            dimension: $dimension
            attributeType: $attributeType
            timePeriod: $timePeriod
            version: $version
            frequency: $frequency
            salesFilter: $salesFilter
            limit: $limit
            offset: $offset
        ) {
            ppgName
            attributeType
            values {
                attributeValue
                salesValueDollars
                percentSalesValue
                perUnitValues {
                    avgPrice
                    maxPrice
                    minPrice
                    mraup
                    basePrice
                    promoPrice
                    __typename
                }
                perEqValues {
                    avgPrice
                    maxPrice
                    minPrice
                    mraup
                    basePrice
                    promoPrice
                    __typename
                }
                __typename
            }
            count
            __typename
        }
    }
`;

export const getPriceLadderChart2 = gql`
    query getPricePointChangeData(
        $metric: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $timePeriod: JSONString!
        $frequency: String!
        $attributeType: SamyaString
        $attributeName: String
        $version: SamyaString!
        $dimension: SamyaString
        $limit: Int!
        $offset: Int!
    ) {
        getPricePointChangeData(
            filters: $filters
            dimension: $dimension
            attributeType: $attributeType
            attributeName: $attributeName
            version: $version
            timePeriod: $timePeriod
            frequency: $frequency
            limit: $limit
            offset: $offset
            metric: $metric
            metricType: $metricType
        ) {
            ppgName
            attributeType
            baseLineValue
            values {
                attributeValue
                diffValue
                __typename
            }
            count
            __typename
        }
    }
`;

export const getDropdownValues = gql`
    query getPriceLadderCompetitorsDropdownValues(
        $attributeType: SamyaString
        $dimension: SamyaString
        $timePeriod: JSONString!
        $globalFilters: JSONString
        $globalFiltersSubset: JSONString
        $searchKeyword: SamyaString
        $limit: Int!
        $offset: Int!
        $defaultCompetitors: JSONString
    ) {
        getPriceLadderCompetitorsDropdownValues(
            attributeType: $attributeType
            dimension: $dimension
            timePeriod: $timePeriod
            globalFilters: $globalFilters
            searchKeyword: $searchKeyword
            globalFiltersSubset: $globalFiltersSubset
            limit: $limit
            offset: $offset
            defaultCompetitors: $defaultCompetitors
        ) {
            attributeType
            values
            count
        }
    }
`;

export const getCompetitorPriceLadderData = gql`
    query getPriceLadderCompetitorsAttributeLevelData(
        $attributeType: SamyaString
        $dimension: SamyaString
        $timePeriod: JSONString!
        $globalFilters: JSONString
        $attributeValues: JSONString
        $limit: Int!
        $offset: Int!
    ) {
        getPriceLadderCompetitorsAttributeLevelData(
            attributeType: $attributeType
            dimension: $dimension
            timePeriod: $timePeriod
            globalFilters: $globalFilters
            attributeValues: $attributeValues
            limit: $limit
            offset: $offset
        ) {
            ppgName
            attributeType
            values {
                attributeValue
                salesValueDollars
                perUnitValues {
                    avgPrice
                    maxPrice
                    minPrice
                    basePrice
                    promoPrice
                }
                perEqValues {
                    avgPrice
                    maxPrice
                    minPrice
                    basePrice
                    promoPrice
                }
            }
        }
    }
`;

export const getCompetitorChart2Data = gql`
    query getCompetitorsPricePointChangeData(
        $metric: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $attributeValues: JSONString
        $timePeriod: JSONString!
        $attributeType: SamyaString
        $dimension: SamyaString
        $limit: Int!
        $offset: Int!
    ) {
        getCompetitorsPricePointChangeData(
            filters: $filters
            dimension: $dimension
            attributeType: $attributeType
            attributeValues: $attributeValues
            timePeriod: $timePeriod
            limit: $limit
            offset: $offset
            metric: $metric
            metricType: $metricType
        ) {
            ppgName
            attributeType
            baseLineValue
            values {
                attributeValue
                diffValue
            }
        }
    }
`;

export const getMultiLineChartData = gql`
    query getPricePointChangeTimeseriesData(
        $metric: SamyaString!
        $metricType: SamyaString!
        $filters: JSONString
        $frequency: String!
        $timePeriod: JSONString!
        $attributeType: SamyaString
        $attributeName: String
        $version: SamyaString!
        $dimension: SamyaString
        $limit: Int!
        $offset: Int!
    ) {
        getPricePointChangeTimeseriesData(
            filters: $filters
            dimension: $dimension
            attributeType: $attributeType
            attributeName: $attributeName
            version: $version
            timePeriod: $timePeriod
            frequency: $frequency
            limit: $limit
            offset: $offset
            metric: $metric
            metricType: $metricType
        ) {
            metric
            attributesLst
            metricData
        }
    }
`;
